import { message, Input, Select, Upload, Popconfirm, Row, Col, Alert, Form as FormInitial } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputItem,
  InputNumberItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
  TourItem,
  SwitchItem,
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, PictureOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import AsistenteDepreciacionLISR from "../../../../Components/AsistenteDepreciacionLISR";

const { Option } = Select;

// Las 5 cuentas de un Activo, cada una con su propio flag de "genera cuenta hija".
const CUENTAS = [
  { campo: "cuentaActivoId", flag: "generarCuentaHijaActivo", label: "Cuenta del Activo" },
  { campo: "cuentaDepreciacionAcumuladaId", flag: "generarCuentaHijaDepreciacionAcumulada", label: "Cuenta de Depreciación Acumulada" },
  { campo: "cuentaCostoGastoActivoId", flag: "generarCuentaHijaCostoGastoActivo", label: "Cuenta de Costo o Gasto" },
  { campo: "cuentaUtilidadActivoId", flag: "generarCuentaHijaUtilidadActivo", label: "Cuenta de Utilidad de Activo" },
  { campo: "cuentaPerdidaActivoId", flag: "generarCuentaHijaPerdidaActivo", label: "Cuenta de Pérdida de Activo" },
];

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class AgregarActivoFijo extends Component {
  formRef = React.createRef();
  refDatosGenerales = React.createRef();
  refImpuestos = React.createRef();
  refTabs = React.createRef();

  state = {
    loading: false,
    openTour: false,
    openAsistenteDepreciacion: false,
    objetoTiposDeActivo: null,
    todosTiposDeActivo: [],
    tipoDeActivoSeleccionado: null,
    objetoUnidades: null,
    objetoCuentaContable: null,
    todasCuentasContables: [],
    objetoImpuestos: null,
    objetoRetenciones: null,
    modalAgregarCuentaContable: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  cerrarAgregarActivoFijo(codigo) {
    this.props.cerrarAgregarActivoFijo(codigo);
    this.setState({ archivosPrincipal: [], archivosTecnica: [], archivosFotos: [] });
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post("activosFijos/selectTiposDeActivo", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({
            todosTiposDeActivo: res.data,
            objetoTiposDeActivo: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
    await axios
      .post("unidades/selectTodasUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUnidades: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
    await axios
      .post("cuentascontables/selectCuentasContablesFinales", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    // Lista completa (no solo las cuentas finales) para poder mostrar el nombre
    // de la cuenta del Tipo de Activo: si esa cuenta ya generó hijas dejó de ser
    // final y no viene en selectCuentasContablesFinales.
    await axios
      .post("cuentascontables/selectTodasCuentasContables", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasCuentasContables: res.data });
      });
    await axios
      .post("impuestos/selectTodosImpuestos", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoImpuestos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
    await axios
      .post("retenciones/selectTodasRetenciones", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoRetenciones: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
    this.setState({ loading: false });
  }

  onChangeTipoDeActivo(familiaId) {
    const tipoDeActivo = this.state.todosTiposDeActivo.find((value) => value._id.toString() === familiaId.toString());
    if (!tipoDeActivo) return;
    this.setState({ tipoDeActivoSeleccionado: tipoDeActivo });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    const archivosPrincipal = this.state.archivosPrincipal.map((f) => ({ name: f.name, url: f.preview || f.url }));
    const archivosTecnica = this.state.archivosTecnica.map((f) => ({ name: f.name, url: f.preview || f.url }));
    const archivosFotos = this.state.archivosFotos.map((f) => ({ name: f.name, url: f.preview || f.url }));
    axios
      .post(
        "activosFijos/agregarActivoFijo",
        { ...values, archivosPrincipal, archivosTecnica, archivosFotos, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un Activo");
          this.formRef.current.resetFields();
          this.setState({ archivosPrincipal: [], archivosTecnica: [], archivosFotos: [] });
          this.cerrarAgregarActivoFijo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y el Activo no se registró");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    let preview = file.url || file.preview;
    if (!preview) {
      preview = await getBase64(file.originFileObj || file);
      file.preview = preview;
    }
    this.setState({ previewVisible: true, previewImage: preview, previewTitle: file.name || "" });
  };

  async customRequestPrincipal(e) {
    const file = e.file;
    const preview = await getBase64(file);
    const fileObj = { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file };
    this.setState({ archivosPrincipal: [...this.state.archivosPrincipal, fileObj] });
    e.onSuccess("ok");
  }
  onRemoveFilePrincipal(file) {
    this.setState({ archivosPrincipal: this.state.archivosPrincipal.filter((f) => f.uid !== file.uid) });
  }
  async customRequestFicha(e) {
    const file = e.file;
    const preview = await getBase64(file);
    const fileObj = { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file };
    this.setState({ archivosTecnica: [...this.state.archivosTecnica, fileObj] });
    e.onSuccess("ok");
  }
  onRemoveFileFicha(file) {
    this.setState({ archivosTecnica: this.state.archivosTecnica.filter((f) => f.uid !== file.uid) });
  }
  async customRequestFotos(e) {
    const file = e.file;
    const preview = await getBase64(file);
    const fileObj = { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file };
    this.setState({ archivosFotos: [...this.state.archivosFotos, fileObj] });
    e.onSuccess("ok");
  }
  onRemoveFileFotos(file) {
    this.setState({ archivosFotos: this.state.archivosFotos.filter((f) => f.uid !== file.uid) });
  }

  nombreCuentaContable(cuentaId) {
    if (!cuentaId) return null;
    const cuenta = this.state.todasCuentasContables.find((value) => value._id.toString() === cuentaId.toString());
    if (!cuenta) return null;
    return cuentaMask(cuenta.nivel1 + cuenta.nivel2 + cuenta.nivel3 + cuenta.nivel4 + cuenta.nivel5) + " - " + cuenta.descripcion;
  }

  // Pista viva de lo que va a pasar con esta cuenta. Quien decide si se genera
  // hija o se comparte es el Tipo de Activo — aquí solo se menciona.
  renderPistaCuenta({ campo, flag, cuentaCapturada }) {
    if (cuentaCapturada) {
      return (
        <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)", marginTop: 2 }}>
          Se usará esta cuenta tal cual; no se generará ninguna subcuenta.
        </div>
      );
    }
    const tipoDeActivo = this.state.tipoDeActivoSeleccionado;
    if (!tipoDeActivo) return null;
    const nombreCuenta = this.nombreCuentaContable(tipoDeActivo[campo]);
    if (!nombreCuenta) {
      return (
        <div style={{ fontSize: 12, color: "#cf1322", marginTop: 2 }}>
          El Tipo de Activo no tiene esta cuenta configurada; si dejas el campo vacío, el Activo quedará sin ella.
        </div>
      );
    }
    return (
      <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)", marginTop: 2 }}>
        {tipoDeActivo[flag]
          ? `Vacío → se generará una subcuenta propia de este Activo, colgada de ${nombreCuenta}.`
          : `Vacío → usará ${nombreCuenta}, compartida con los demás Activos de este tipo.`}
      </div>
    );
  }

  renderCuentaOverride({ campo, flag, label }) {
    return (
      <FormItem
        label={label}
        margin
        key={campo}
        tooltip={{ title: `Vacío = hereda de su Tipo de Activo (y si ese tipo genera cuenta hija, se le crea su propia subcuenta). Si capturas una cuenta aquí, se usa esa exactamente y no se genera ninguna subcuenta.` }}
      >
        <FormItem noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const cuentaCapturada = !!getFieldValue(campo);
            return (
              <>
                <Input.Group compact>
                  <FormItem name={campo} noStyle>
                    <SelectItem placeholder="Vacío = hereda del Tipo de Activo" width="85%" allowClear>
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                  <ButtonItem
                    blanco
                    icon={<PlusOutlined />}
                    style={{ width: "13%", marginLeft: 5 }}
                    onClick={this.abrirAgregarCuentaContable.bind(this)}
                  />
                </Input.Group>
                {this.renderPistaCuenta({ campo, flag, cuentaCapturada })}
              </>
            );
          }}
        </FormItem>
      </FormItem>
    );
  }

  renderUpload({ name, fileListKey, customRequest, onRemove, label, sinRestriccionTipo }) {
    return (
      <FormItem name={name} noStyle>
        <Upload
          listType="picture-card"
          itemRender={(originNode, file) => (
            <div style={{ display: "inline-block", textAlign: "center", marginRight: 8 }}>
              {originNode}
              <div style={{ fontSize: 12, marginTop: 6, maxWidth: 104, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {file.name}
              </div>
            </div>
          )}
          showUploadList={{
            showRemoveIcon: true,
            showPreviewIcon: true,
            removeIcon: (file) => (
              <Popconfirm title="Seguro que quieres eliminar el archivo" onConfirm={() => this[onRemove](file)} okText="Si" cancelText="No">
                <DeleteOutlined onClick={(e) => e.preventDefault()} />
              </Popconfirm>
            ),
          }}
          fileList={this.state[fileListKey]}
          customRequest={this[customRequest].bind(this)}
          onPreview={this.handlePreview}
          multiple={fileListKey !== "archivosPrincipal"}
          maxCount={fileListKey === "archivosPrincipal" ? 1 : undefined}
          accept={sinRestriccionTipo ? undefined : "image/*"}
          beforeUpload={
            sinRestriccionTipo
              ? undefined
              : (file) => {
                const isImage = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isImage) {
                  message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
                  return Upload.LIST_IGNORE;
                }
                if (!isLt5M) {
                  message.error(`${file.name} excede el tamaño máximo de 5MB`);
                  return Upload.LIST_IGNORE;
                }
                return true;
              }
          }
        >
          <div>
            <PictureOutlined />
            <div style={{ marginTop: 8 }}>{label}</div>
          </div>
        </Upload>
      </FormItem>
    );
  }

  render() {
    const allTabs = [
      {
        key: "depreciacion",
        label: "Depreciación",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="CONFIGURACIÓN DE DEPRECIACIÓN (OVERRIDES)" lg="100%">
            <div style={{ marginBottom: 8, fontSize: 12, color: "#8c8c8c", lineHeight: 1.4 }}>
              Todo lo de aquí es <strong>opcional</strong>: si se deja vacío, el Activo hereda la configuración de su Tipo de Activo.
              Solo captura un valor si este Activo en particular necesita ser diferente (ej. una laptop con un % de depreciación anual distinto al resto de su tipo).
            </div>
            <Row gutter={[16, 8]}>
              <Col xs={24} md={12}>
                <FormItem
                  name="metodoDepreciacion"
                  label="Método de Depreciación"
                  margin
                  tooltip={{ title: "Método usado para calcular cuánto se deprecia cada periodo. Por ahora solo está implementada Línea Recta: (Costo − Valor Residual) × Depreciación Anual %." }}
                >
                  <SelectItem placeholder="Hereda del Tipo de Activo" allowClear>
                    <Option value={1}>Línea recta</Option>
                  </SelectItem>
                </FormItem>
                <FormItem
                  name="frecuenciaDepreciacion"
                  label="Frecuencia de Depreciación"
                  margin
                  tooltip={{ title: "Cada cuánto se corre la depreciación de este Activo: Mensual, Bimestral (cada 2 meses), Trimestral (cada 3), Semestral (cada 6) o Anual (cada 12)." }}
                >
                  <SelectItem placeholder="Hereda del Tipo de Activo" allowClear>
                    <Option value={1}>Mensual</Option>
                    <Option value={2}>Bimestral</Option>
                    <Option value={3}>Trimestral</Option>
                    <Option value={4}>Semestral</Option>
                    <Option value={5}>Anual</Option>
                  </SelectItem>
                </FormItem>
                <FormItem
                  name="porcentajeDepreciacionAnual"
                  label="Depreciación Anual (%)"
                  margin
                  tooltip={{ title: "Qué porcentaje del costo (menos el valor residual) se espera depreciar por completo cada año, ej. 10% anual = 10 años de vida útil." }}
                >
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" porcentaje min={0.01} max={100} />
                </FormItem>
                <FormItem
                  name="valorResidualPorcentaje"
                  label="Valor Residual"
                  margin
                  tooltip={{ title: "Porcentaje del costo de adquisición que NUNCA se deprecia (lo que se espera recuperar/valga el activo al final de su vida útil). Ej. 10% de un costo de $10,000 = $1,000 de valor residual." }}
                >
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" porcentaje min={0} max={100} />
                </FormItem>
              </Col>
              <Col xs={24} md={12}>
                <FormItem
                  name="prefijoSerieActivo"
                  label="Prefijo de Serie"
                  margin
                  pattern
                  tooltip={{ title: "Texto fijo que antecede al folio consecutivo de cada unidad física de este Activo (ej. 'MOB-' produce folios MOB-00001, MOB-00002...)." }}
                >
                  <InputItem placeholder="Hereda del Tipo de Activo" />
                </FormItem>
                <FormItem
                  name="longitudFolioActivo"
                  label="Longitud de Folio"
                  margin
                  tooltip={{ title: "Cuántos dígitos lleva el consecutivo del folio, rellenando con ceros a la izquierda. Ej. longitud 5 → 00042." }}
                >
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" min={1} max={10} />
                </FormItem>
                <FormItem
                  name="siguienteFolioActivo"
                  label="Contador propio (inicia en)"
                  margin
                  tooltip={{ title: "Si se captura un número aquí, este Activo tendrá su PROPIO consecutivo de folio, independiente del que comparten los demás Activos de su mismo Tipo de Activo." }}
                >
                  <InputNumberItem placeholder="Compartir contador del Tipo de Activo" min={1} />
                </FormItem>
              </Col>
            </Row>
            <div style={{ marginTop: 8 }}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Cómo se resuelve cada cuenta"
                description={
                  <span>
                    Si dejas la cuenta <strong>vacía</strong>, el Activo hereda la de su Tipo de Activo: si ese tipo está marcado para <strong>generar cuenta hija</strong>, se le crea automáticamente su propia subcuenta; si no, comparte la cuenta del tipo tal cual.
                    Si <strong>capturas</strong> una cuenta aquí, se usa esa exactamente y no se genera ninguna subcuenta.
                  </span>
                }
              />
              {CUENTAS.map((cuenta) => this.renderCuentaOverride(cuenta))}
            </div>
          </DynamicCardForm>
        ),
      },
      {
        key: "archivoGrafico",
        label: "Archivo Gráfico",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="ARCHIVO GRÁFICO" lg="100%">
            <div style={{ marginBottom: 8, fontSize: 12, color: "#8c8c8c", lineHeight: 1.4 }}>
              <strong>Foto Principal:</strong> una sola imagen representativa del activo (máx. 5MB, JPG/PNG/WEBP).{" "}
              <strong>Ficha Técnica:</strong> manuales/especificaciones en cualquier formato.{" "}
              <strong>Fotos:</strong> fotografías adicionales del estado físico del activo.
            </div>
            <Row gutter={[12, 4]}>
              <Col flex="1">
                {this.renderUpload({ name: "fotoPrincipalUpload", fileListKey: "archivosPrincipal", customRequest: "customRequestPrincipal", onRemove: "onRemoveFilePrincipal", label: "Foto Principal" })}
              </Col>
              <Col flex="1">
                {this.renderUpload({ name: "fichaTecnicaUpload", fileListKey: "archivosTecnica", customRequest: "customRequestFicha", onRemove: "onRemoveFileFicha", label: "Ficha Técnica", sinRestriccionTipo: true })}
              </Col>
              <Col flex="1">
                {this.renderUpload({ name: "fotosUpload", fileListKey: "archivosFotos", customRequest: "customRequestFotos", onRemove: "onRemoveFileFotos", label: "Fotos" })}
              </Col>
            </Row>
          </DynamicCardForm>
        ),
      },
    ];

    const steps = [
      {
        title: "Alta de Activo",
        description: "Este formulario da de alta un Activo (el 'modelo' o tipo de bien, ej. 'Laptop Dell Latitude'). Después, en Inventario de Activos podrás dar de alta cada unidad física individual (cada laptop concreta) con su propio número de serie y fecha de compra.",
        target: null,
      },
      {
        title: "Datos Generales",
        description: "Elige primero el Tipo de Activo (define las cuentas contables y reglas de depreciación por default), luego captura la descripción, unidad e impuestos/retenciones que aplican a este Activo.",
        target: () => this.refDatosGenerales.current,
      },
      {
        title: "Pestaña Depreciación",
        description: "Haz clic en la pestaña 'Depreciación' (abajo) para sobreescribir, solo para este Activo, el método/frecuencia/depreciación anual/valor residual y las cuentas contables — si no capturas nada, hereda todo de su Tipo de Activo.",
        target: () => this.refTabs.current,
      },
      {
        title: "Pestaña Archivo Gráfico",
        description: "Haz clic en la pestaña 'Archivo Gráfico' (abajo) para subir una foto principal, ficha técnica y fotos adicionales del activo.",
        target: () => this.refTabs.current,
      },
    ];

    return (
      <>
        <ModalItem
          title={
            <span>
              Agregar Activo{" "}
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openAsistenteDepreciacion: true })}>
                Asistente de Depreciación (Ley ISR)
              </ButtonItem>
            </span>
          }
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarActivoFijo.bind(this)}
          paddingTop
          width={1000}
        >
          <Form
            ref={this.formRef}
            name="agregarActivoFijo"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <div ref={this.refDatosGenerales}>
              <GeneralFormLayout
                cards={[
                  {
                    title: "DATOS GENERALES",
                    lg: 24,
                    content: (
                      <Row gutter={[16, 8]}>
                        <Col xs={24} lg={17}>
                          <FormItem
                            name="familiaId"
                            label="Tipo de Activo"
                            required
                            margin
                            tooltip={{ title: "Categoría contable del Activo: define las cuentas de mayor, método/frecuencia de depreciación y reglas de folio que este Activo hereda por default." }}
                          >
                            <SelectItem placeholder="Tipo de Activo" onChange={this.onChangeTipoDeActivo.bind(this)}>
                              {this.state.objetoTiposDeActivo}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            name="descripcion"
                            label="Descripción"
                            required
                            max={150}
                            margin
                            pattern
                            tooltip={{ title: "Nombre corto del Activo, ej. 'Laptop Dell Latitude 5420'. Aparece en los listados y en la etiqueta impresa." }}
                          >
                            <InputItem placeholder="Ej. Laptop Dell Latitude" />
                          </FormItem>
                          <FormItem
                            name="descripcionLarga"
                            label="Descripción Larga"
                            required
                            margin
                            pattern
                            tooltip={{ title: "Descripción detallada del Activo (especificaciones, marca/modelo completos, etc.)." }}
                          >
                            <TextAreaItem placeholder="Descripción detallada" rows={2} />
                          </FormItem>
                          <FormItem
                            label="Unidad"
                            margin
                            tooltip={{ title: "Unidad de medida del Activo — normalmente 'Pieza' para un activo fijo." }}
                          >
                            <Input.Group compact>
                              <FormItem name="unidadId" required noStyle>
                                <SelectItem placeholder="Unidad" width="calc(100% - 32px)">
                                  {this.state.objetoUnidades}
                                </SelectItem>
                              </FormItem>
                            </Input.Group>
                          </FormItem>
                          <FormItem
                            name="clave"
                            label="Clave"
                            margin
                            pattern
                            tooltip={{ title: "Clave interna corta para identificar este Activo (opcional)." }}
                          >
                            <InputItem placeholder="Clave" />
                          </FormItem>
                          <FormItem
                            name="codigoBarras"
                            label="Código de Barras"
                            margin
                            pattern
                            tooltip={{ title: "Código de barras del Activo, si aplica (opcional; cada unidad física además tendrá su propio folio/serie individual)." }}
                          >
                            <InputItem placeholder="Código de barras" />
                          </FormItem>
                          <FormItem
                            name="costo"
                            label="Costo de Referencia"
                            margin
                            tooltip={{ title: "Costo sugerido solo como referencia/catálogo. El costo REAL que se deprecia es el que se captura al dar de alta cada unidad física en Inventario de Activos (dos unidades del mismo Activo pueden costar distinto)." }}
                          >
                            <InputNumberItem placeholder="Costo de referencia" dinero />
                          </FormItem>
                          <FormItem
                            name="compra"
                            label="Permitir Compra"
                            margin
                            initialValue={true}
                            valuePropName="checked"
                            labelCol={{ span: 19 }}
                            wrapperCol={{ span: 5 }}
                            tooltip={{ title: "Permite comprar este Activo en Órdenes de Compra, Facturas sin Orden de Compra, Caja Chica y Remisiones. Al recibirlo se da de alta una unidad (con su folio y su etiqueta) por cada pieza recibida. Además hay que relacionarlo con el proveedor en Proveedores → Relación Insumo - Proveedor." }}
                          >
                            <SwitchItem />
                          </FormItem>
                          <FormItem
                            name="venta"
                            label="Permitir Venta"
                            margin
                            initialValue={false}
                            valuePropName="checked"
                            labelCol={{ span: 19 }}
                            wrapperCol={{ span: 5 }}
                            tooltip={{ title: "Normalmente se deja apagado. Un activo fijo se vende desde Inventario de Activos → Vender Activo, que es el flujo que calcula la utilidad o pérdida contra el valor en libros y cancela su depreciación acumulada. Si lo prendes, el Activo también aparecerá como renglón normal en ventas, listas de precios y punto de venta — y venderlo por ahí NO hace esos asientos." }}
                          >
                            <SwitchItem />
                          </FormItem>
                        </Col>
                        <Col xs={24} lg={7}>
                          <div ref={this.refImpuestos}>
                            <div style={{ textAlign: "center", marginBottom: 8, fontWeight: 600, fontSize: 13 }}>IMPUESTOS</div>
                            <FormInitial.List name="impuestos">
                              {(fields, { add, remove }) => (
                                <>
                                  <div style={{ maxHeight: 140, overflowY: "auto", paddingRight: 4 }}>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                        <Col flex="1">
                                          <FormItem name={[name, "impuestoId"]} required noStyle>
                                            <SelectItem width="100%" placeholder="Impuesto">
                                              {this.state.objetoImpuestos}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col flex="28px">
                                          <DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                  <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>
                                    Agregar
                                  </ButtonItem>
                                </>
                              )}
                            </FormInitial.List>
                            <div style={{ textAlign: "center", margin: "12px 0 8px", fontWeight: 600, fontSize: 13 }}>RETENCIONES</div>
                            <FormInitial.List name="retenciones">
                              {(fields, { add, remove }) => (
                                <>
                                  <div style={{ maxHeight: 140, overflowY: "auto", paddingRight: 4 }}>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                        <Col flex="1">
                                          <FormItem name={[name, "retencionId"]} required noStyle>
                                            <SelectItem width="100%" placeholder="Retención">
                                              {this.state.objetoRetenciones}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col flex="28px">
                                          <DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                  <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>
                                    Agregar
                                  </ButtonItem>
                                </>
                              )}
                            </FormInitial.List>
                          </div>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
              />
            </div>
            <div ref={this.refTabs}>
              <TabbedDynamicTable
                formInstance={this.formRef}
                defaultActiveKey="depreciacion"
                tabs={allTabs}
              />
            </div>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={steps}
        />
        <AsistenteDepreciacionLISR
          visible={this.state.openAsistenteDepreciacion}
          onClose={() => this.setState({ openAsistenteDepreciacion: false })}
          onAplicar={({ porcentaje, metodo }) =>
            this.formRef.current.setFieldsValue({
              porcentajeDepreciacionAnual: porcentaje,
              metodoDepreciacion: metodo,
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarActivoFijo);
